import CRC32 from 'crc-32'
import { mach_mqttSender } from '@/api/anycubic_axios';

class MachMQTTClient {
    constructor(identity) {
        this.identity = identity;
        this.connected = false;
    }
    destory() {

        const response = mach_mqttSender.del("destroy", { "identity": this.identity })
        return response.data;
    }
    async connect(url, device_type, username, password, clientid, Certificate, PrivateKey, KeyStore) {
        const response = await mach_mqttSender.put("connect", {
            "identity": this.identity,
            "url": url,
            "device_type": device_type, "username": username,
            "password": password, "clientid": clientid,
            "Certificate": Certificate, "PrivateKey": PrivateKey, "KeyStore": KeyStore
        })
        return response.data;
    }
    disconnect(isRequest= false) {
        if (this.connected || isRequest) {
            const response = mach_mqttSender.put("disconnect", { "identity": this.identity });
            return response.data;
        }
        return -1;
    }
    subscribe(topic) {
        if (this.connected) {
            const response = mach_mqttSender.post("subscribe", { "identity": this.identity, "topic": topic })
            return response.data;
        }
        return -1;
    }

    unsubscribe(topic) {
        if (this.connected) {
            const response = mach_mqttSender.del("unsubscribe", { "identity": this.identity, "topic": topic });
            return response.data;
        }
        return -1;
    }
    async publish(topic, payload) {
        if (this.connected) {
            const response = await mach_mqttSender.post("publish", { identity: this.identity, topic: topic, payload: JSON.stringify(payload) })
            return response.data;
        }
        return -1;
    }

    async is_connected() {
        const response =
            await mach_mqttSender.get("connected", { "identity": this.identity })
        that.connected = response.data;
        return response.data;
    }
    set_event_callback(callback) {
        let that = this
        window[`mach_event_call_${this.identity}`] = (a, c, msg) => {
            if (a == 1) {
                that.connected = c == 0;
            }
            callback(a, c, msg);
            console.log("局域网MQTT事件:", a, c, msg);
        };
        const response = mach_mqttSender.post("event_call", { "identity": this.identity, "script": `window.mach_event_call_${this.identity}` })
        return response.data;
    }
    set_message_callback(callback) {
        window[`mach_data_call_${this.identity}`] = (t, p) => {
            callback(t, p);
            console.log("局域网MQTT数据:", t, p);
        };
        const response = mach_mqttSender.post("data_call", { "identity": this.identity, "script": `window.mach_data_call_${this.identity}` })
        return response.data;
    }
}




/**
 * 创建并返回一个 MachMQTTClient 实例。
 * 
 * @param {string} cn - 唯一码（暂定为 UUID）。
 * @param {string} objectName - 对象名。
 * @returns {MachMQTTClient|null} 返回一个 MachMQTTClient 实例，如果创建失败则返回 null。
 */

export async function CreateMachClient(cn, objectName) {
    const crc = Math.abs(CRC32.str(cn + objectName));

    const response = await mach_mqttSender.post("create", { "cn": cn, "identity": crc })


    if (response.data == 0 || response.data == -1) {
        return new MachMQTTClient(crc)
    }
    return null
}

